import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatDialogConfig } from '@angular/material';
import 'jspdf-autotable';
import { CustomDateComponent } from '../.../../customdate/custom-date.component';
import * as moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
var EmsreportComponent = /** @class */ (function () {
    function EmsreportComponent(reportService, matDialog, ngxLoader, EmsdashboardService, route, deviceManagerSer, _dashboardService, transMngSer) {
        this.reportService = reportService;
        this.matDialog = matDialog;
        this.ngxLoader = ngxLoader;
        this.EmsdashboardService = EmsdashboardService;
        this.route = route;
        this.deviceManagerSer = deviceManagerSer;
        this._dashboardService = _dashboardService;
        this.transMngSer = transMngSer;
        this.report1Columns = ["Transformer Id", "Deviceid", "DATE", "Winding_Temperature", "Winding_Temp_By_Cal", "Ambient_Temperature", "Humidity", "Oil_Temperature", "Oil_Level", "R_Ph_N", "Y_Ph_N", "B_Ph_N", "Average_Voltage", "RY_Voltage", "YB_Voltage", "BR_Voltage", "L1", "L2", "L3", "LN", "I1", "I2", "I3", "R1", "R2", "R3", "R_Power_Factor", "Y_Power_Factor", "B_Power_Factor", "Avg_Power_Factor", "R_Active_Power", "Y_Active_Power", "B_Active_Power", "3_Phase_Active_Power", "R_Reactive_Power", "Y_Reactive_Power", "B_Reactive_Power", "3_Phase_Reactive_Power", "R_apparent_Power", "Y_apparent_Power", "B_apparent_Power", "3_Phase_Apparent_Power", "Fequency", "Device_Temperature", "VR_THD", "VY_THD", "VB_THD", "IR_THD", "IY_THD", "IB_THD", "RP_THD", "YP_THD", "BP_THD", "System_kwh", "System_kvArh"];
        this.filter = {};
        this.transformerIds = [];
        this.deviceIds = [];
        this.timeOptions = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
        this.parametersOption = ['All', 'Physical Parameters', "Electrical Parameters"];
        this.reportData = [];
        this.electricalParams = [];
        this.allParameters = [];
        this.windingtemprature = [];
        this.heading = [];
    }
    EmsreportComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.ngxLoader.start();
                this.deviceManagerSer.getEMSDeviceId(JSON.parse(localStorage.getItem('userData')).userid).subscribe(function (response) {
                    var Deviceids = [];
                    response.result.forEach(function (value) {
                        Deviceids.push(value.deviceId + "(" + value.sitename + ")");
                    });
                    console.log("what is inside this", Deviceids);
                    _this.filters('DeviceID', Deviceids[0]);
                    _this.deviceIds = Deviceids;
                    _this.selectedDevice = Deviceids[0];
                });
                this.ngxLoader.stop();
                return [2 /*return*/];
            });
        });
    };
    EmsreportComponent.prototype.filters = function (type, param) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var meterid_1, duration, meterid_2, dialogConfig, dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                param = param.split('(')[0];
                if (type == "DeviceID") {
                    this.ngxLoader.startLoader('emsReport');
                    this.device = param;
                    this.transMngSer.getEnergyMeters(param).toPromise().then(function (response) {
                        var energyMeterId = [];
                        response.result.forEach(function (value) {
                            energyMeterId.push(value.meterSerialNumber + "(" + value.assetName + ")");
                        });
                        _this.selectedEnergyMeter = energyMeterId[0];
                        // energyMeterId.push("All");
                        _this.meterSerialNumber = energyMeterId;
                        _this.meterid = energyMeterId[0].split('(')[0];
                        _this.meteridforParameters = energyMeterId[0].split('(')[0];
                        _this.timeFilter = _this.timeOptions[0];
                        _this.transMngSer.getEnergyMeterReportData({ "meterid": energyMeterId[0].split('(')[0], "deviceid": _this.device, "duration": _this.timeOptions[0] }).toPromise().then(function (response) {
                            if (response.result.length > 0) {
                                _this.EmsdashboardService.getParameterConfig(energyMeterId[0].split('(')[0]).toPromise().then(function (response1) {
                                    if (response1.result.length > 0) {
                                        var Parameters = response1.result[0];
                                        var parameterList = ['Deviceid', 'DATE', 'energyMeterId'];
                                        delete Parameters['deletedFlag'];
                                        delete Parameters['id'];
                                        delete Parameters['energyMeterId'];
                                        var i = 0;
                                        if (i == 0) {
                                            for (var key in Parameters) {
                                                if (Parameters[key] == '1') {
                                                    parameterList.push(key);
                                                }
                                                i++;
                                            }
                                        }
                                        _this.dataSource = new MatTableDataSource(response.result);
                                        _this.heading = parameterList;
                                        console.log("kjhfsdksdfsdffdsdf", parameterList);
                                        _this.dataSource.paginator = _this.paginator;
                                        _this.dataSource.sort = _this.sort;
                                    }
                                });
                                _this.ngxLoader.stopLoader('emsReport');
                            }
                            else {
                                _this.ngxLoader.stopLoader('emsReport');
                            }
                        });
                    });
                }
                if (type == "energyMeter") {
                    this.ngxLoader.startLoader('emsReport');
                    this.meterid = param;
                    meterid_1 = param;
                    if (param == "All") {
                        meterid_1 = this.meteridforParameters;
                    }
                    this.transMngSer.getEnergyMeterReportData({ "meterid": param, "duration": this.timeFilter, "deviceid": this.device, "range": this.customDateRange }).toPromise().then(function (response) {
                        if (response.result.length > 0) {
                            _this.EmsdashboardService.getParameterConfig(meterid_1.split('(')[0]).toPromise().then(function (response1) {
                                if (response1.result.length > 0) {
                                    var Parameters = response1.result[0];
                                    var parameterList = ['Deviceid', 'DATE', 'energyMeterId'];
                                    delete Parameters['deletedFlag'];
                                    delete Parameters['id'];
                                    delete Parameters['energyMeterId'];
                                    for (var key in Parameters) {
                                        if (Parameters[key] == '1') {
                                            parameterList.push(key);
                                        }
                                    }
                                    console.log("aksdkjsa", parameterList);
                                    _this.dataSource = new MatTableDataSource(response.result);
                                    _this.heading = parameterList;
                                    _this.dataSource.paginator = _this.paginator;
                                    _this.dataSource.sort = _this.sort;
                                }
                                else {
                                    _this.dataSource = [];
                                }
                            });
                            _this.ngxLoader.stopLoader('emsReport');
                        }
                        else {
                            _this.ngxLoader.stopLoader('emsReport');
                        }
                    });
                }
                if (type == "date") {
                    this.ngxLoader.startLoader('emsReport');
                    this.timeFilter = param;
                    duration = void 0;
                    if (param == "Today") {
                        duration = "Today";
                    }
                    else if (param == "Yesterday") {
                        duration = "Yesterday";
                    }
                    else if (param == "This Week") {
                        duration = "This Week";
                    }
                    else if (param == "This Month") {
                        duration = "This Month";
                    }
                    else if (param == "Last Month") {
                        duration = "Last Month";
                    }
                    meterid_2 = this.meterid;
                    if (this.meterid == "All") {
                        meterid_2 = this.meteridforParameters;
                    }
                    if (param == "Custom") {
                        dialogConfig = new MatDialogConfig();
                        dialogRef = this.matDialog.open(CustomDateComponent, {
                            autoFocus: false,
                            height: '350px', width: '450px', data: { "details": "", "action": "Add", selectedDate: this.customeSelectedDate }
                        });
                        dialogRef.afterClosed().subscribe(function (value) {
                            _this.customDateRange = value;
                            _this.transMngSer.getEnergyMeterReportData({ "meterid": _this.meterid, "duration": param, "range": value, "deviceid": _this.device }).toPromise().then(function (response) {
                                if (response.result.length > 0) {
                                    _this.EmsdashboardService.getParameterConfig(meterid_2.split('(')[0]).toPromise().then(function (response1) {
                                        if (response1.result.length > 0) {
                                            var Parameters = response1.result[0];
                                            var parameterList = ['Deviceid', 'DATE', 'energyMeterId'];
                                            delete Parameters['deletedFlag'];
                                            delete Parameters['id'];
                                            delete Parameters['energyMeterId'];
                                            var i = 0;
                                            if (i == 0) {
                                                for (var key in Parameters) {
                                                    if (Parameters[key] == '1') {
                                                        parameterList.push(key);
                                                    }
                                                    i++;
                                                }
                                            }
                                            _this.dataSource = new MatTableDataSource(response.result);
                                            _this.heading = Object.keys(response.result[0]);
                                            _this.dataSource.paginator = _this.paginator;
                                            _this.dataSource.sort = _this.sort;
                                        }
                                        else {
                                            _this.dataSource = [];
                                        }
                                    });
                                    _this.ngxLoader.stopLoader('emsReport');
                                }
                                else {
                                    _this.ngxLoader.stopLoader('emsReport');
                                }
                            });
                        });
                    }
                    else {
                        this.transMngSer.getEnergyMeterReportData({ "meterid": this.meterid, "duration": duration, "deviceid": this.device }).toPromise().then(function (response) {
                            if (response.result.length > 0) {
                                _this.EmsdashboardService.getParameterConfig(meterid_2).toPromise().then(function (response1) {
                                    if (response1.result.length > 0) {
                                        var Parameters = response1.result[0];
                                        var parameterList = ['Deviceid', 'DATE', 'energyMeterId'];
                                        delete Parameters['deletedFlag'];
                                        delete Parameters['id'];
                                        delete Parameters['energyMeterId'];
                                        var i = 0;
                                        if (i == 0) {
                                            for (var key in Parameters) {
                                                if (Parameters[key] == '1') {
                                                    parameterList.push(key);
                                                }
                                                i++;
                                            }
                                        }
                                        _this.dataSource = new MatTableDataSource(response.result);
                                        _this.heading = parameterList;
                                        _this.dataSource.paginator = _this.paginator;
                                        _this.dataSource.sort = _this.sort;
                                    }
                                });
                                _this.ngxLoader.stopLoader('emsReport');
                            }
                            else {
                                _this.dataSource = [];
                                _this.ngxLoader.stopLoader('emsReport');
                            }
                        });
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    EmsreportComponent.prototype.formatDate = function (param) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (param === 'Today') {
                var d = new Date(), month = '' + (d.getMonth() + 1), day = '' + d.getDate(), year = d.getFullYear();
                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;
                resolve({ 'date': [year, month, day].join('-'), 'filter': param });
                // return [year, month, day].join('-');
            }
            else if (param === 'Yesterday') {
                var d = new Date(), month = '' + (d.getMonth() + 1), day = '' + (d.getDate() - 1), year = d.getFullYear();
                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;
                resolve({ 'date': [year, month, day].join('-'), 'filter': param });
                //return [year, month, day].join('-');
            }
            else if (param === 'Last Month') {
                resolve({ 'startDate': moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), 'endDate': moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'), 'filter': param });
                // resolve('&' + `startDate=${[year, month, day].join('-')}` + '&' + `endDate=${[year, month, 30].join('-')}` +  '&' + `filter=${param}`);
                // resolve({'startDate':[year, month, day].join('-'), 'endDate':[year, month, 30].join('-')});
            }
            else if (param === 'This Month') {
                resolve({ 'startDate': moment().startOf('month').format('YYYY-MM-DD'), 'endDate': moment().endOf('month').format('YYYY-MM-DD'), 'filter': param });
                // resolve('&' + `startDate=${[year, month, day].join('-')}` + '&' + `endDate=${[year, month, 30].join('-')}` +  '&' + `filter=${param}`);
            }
            else if (param === 'This Week') {
                resolve({ 'startDate': moment().startOf('week').format('YYYY-MM-DD'), 'endDate': moment().endOf('week').format('YYYY-MM-DD'), 'filter': param });
                //  resolve('&' + `startDate=${[year, month, startDate].join('-')}` + '&' + `endDate=${[year, month, day].join('-')}` +  '&' + `filter=${param}`);
            }
            else if (param === 'Custom') {
                var dialogConfig = new MatDialogConfig();
                var dialogRef = _this.matDialog.open(CustomDateComponent, {
                    autoFocus: false,
                    height: '350px', width: '450px', data: { "details": "", "action": "Add", selectedDate: _this.customeSelectedDate }
                });
                dialogRef.afterClosed().subscribe(function (value) {
                    console.log("Value=======", value);
                    _this.customeSelectedDate = value;
                    resolve({ 'startDate': value.startDate, 'endDate': value.endDate, 'filter': param });
                });
            }
        });
    };
    EmsreportComponent.prototype.exportToPdf = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var widths, _a, docDefinition, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        widths = new Array(this.report1Columns.length).fill('1%');
                        console.log('WIDTHS:', widths, this.report1Columns);
                        _a = this;
                        return [4 /*yield*/, this.formatData(this.data)];
                    case 1:
                        _a.reportData = _b.sent();
                        console.log('Report data length:', this.reportData[0].length);
                        console.log('Formatted Data:', this.reportData[0]);
                        console.log('DATA TO BIND:', this.reportData);
                        docDefinition = {
                            info: {
                                title: 'Transformer Report',
                            },
                            pageOrientation: 'landscape',
                            pageSize: '4A0',
                            content: [
                                {
                                    table: {
                                        // headers are automatically repeated if the table spans over multiple pages
                                        // you can declare how many rows should be treated as headers
                                        headerRows: 1,
                                        // widths: [ '1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%','1.5%', '1.5%' ],
                                        width: widths,
                                        //   body: [
                                        //      "serialnumber", "DATE", "Winding_Temperature", "Ambient_Temperature", "Humidity", "Oil_Temperature", "Oil_Level", "R_Ph_N", "Y_Ph_N", "B_Ph_N", "Average_Voltage", "RY_Voltage", "YB_Voltage", "BR_Voltage", "L1", "L2", "L3", "LN", "I1", "I2", "I3", "R1", "R2", "R3", "R_Power_Factor", "Y_Power_Factor", "B_Power_Factor", "Avg_Power_Factor", "R_Active_Power", "Y_Active_Power", "B_Active_Power", "3_Phase_Active_Power", "R_Reactive_Power", "Y_Reactive_Power", "B_Reactive_Power", "3_Phase_Reactive_Power", "R_apparent_Power", "Y_apparent_Power", "B_apparent_Power", "3_Phase_Apparent_Power", "Fequency", "Energy_Meter_Temprature", "VR_THD", "VY_THD", "VB_THD", "IR_THD", "IY_THD", "IB_THD", "RP_THD", "YP_THD", "BP_THD", "System_kwh", "System_kvArh", "Deviceid", "Parameter1", "Parameter2", "Parameter3", "Parameter4", "Parameter5", "Parameter6", "Parameter7", "Parameter8", "Parameter9", "Parameter10" ],
                                        //     [ "serialnumber", "DATE", "Winding_Temperature", "Ambient_Temperature", "Humidity", "Oil_Temperature", "Oil_Level", "R_Ph_N", "Y_Ph_N", "B_Ph_N", "Average_Voltage", "RY_Voltage", "YB_Voltage", "BR_Voltage", "L1", "L2", "L3", "LN", "I1", "I2", "I3", "R1", "R2", "R3", "R_Power_Factor", "Y_Power_Factor", "B_Power_Factor", "Avg_Power_Factor", "R_Active_Power", "Y_Active_Power", "B_Active_Power", "3_Phase_Active_Power", "R_Reactive_Power", "Y_Reactive_Power", "B_Reactive_Power", "3_Phase_Reactive_Power", "R_apparent_Power", "Y_apparent_Power", "B_apparent_Power", "3_Phase_Apparent_Power", "Fequency", "Energy_Meter_Temprature", "VR_THD", "VY_THD", "VB_THD", "IR_THD", "IY_THD", "IB_THD", "RP_THD", "YP_THD", "BP_THD", "System_kwh", "System_kvArh", "Deviceid", "Parameter1", "Parameter2", "Parameter3", "Parameter4", "Parameter5", "Parameter6", "Parameter7", "Parameter8", "Parameter9", "Parameter10" ],
                                        //    // [ { text: 'Bold value', bold: true }, 'Val 2', 'Val 3', 'Val 4' ]
                                        //   ]
                                        body: this.reportData,
                                    }
                                }
                            ]
                        };
                        this.ngxLoader.start();
                        pdfMake.createPdf(docDefinition).download();
                        this.ngxLoader.stop();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        console.log('ERROR:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EmsreportComponent.prototype.formatData = function (data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var dataArr = [];
            var elementCols = Object.keys(data[0]);
            var diffCols = elementCols.filter(function (x) { return !_this.reportColumns.includes(x); });
            dataArr.push(_this.reportColumns);
            data.forEach(function (element) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var rowValues;
                return tslib_1.__generator(this, function (_a) {
                    rowValues = [];
                    this.reportColumns.forEach(function (col) {
                        rowValues.push(element[col]);
                    });
                    console.log('RE ARRANGED COLS:', rowValues);
                    // delete element['Energy_Meter_Temprature'];
                    //  dataArr.push(Object.values(element));
                    dataArr.push(rowValues);
                    return [2 /*return*/];
                });
            }); });
            var finalArr = dataArr.filter(function (x) { return !Object.keys(x).includes(diffCols.join(",")); });
            resolve(dataArr);
        });
    };
    EmsreportComponent.prototype.deleteDynamicColumns = function (element, cols) {
        return new Promise(function (resolve, reject) {
            cols.forEach(function (col) {
                delete element[col];
            });
            resolve(element);
        });
    };
    EmsreportComponent.prototype.fetchReportData = function (filter) {
        var _this = this;
        this.ngxLoader.start();
        this.dataSource = null;
        console.log('kasdjasduhaiudbijnijnoaskdoansoddjoasd', filter);
        this._dashboardService.getHvLvDiff(filter).subscribe(function (response) {
            console.log("Downtime Data", response);
            _this.heading = Object.keys(response.data[0]);
            console.log("Heading Data", _this.heading);
            _this.dataSource = new MatTableDataSource(response.data);
            _this.dataSource.paginator = _this.paginator;
            _this.dataSource.sort = _this.sort;
        });
        this.ngxLoader.stop();
    };
    EmsreportComponent.prototype.generateDataArray = function (data) {
        var reportData = [];
        var rowdata;
        return new Promise(function (resolve, reject) {
            data.forEach(function (element) {
                rowdata = Object.values(element);
            });
            resolve(rowdata);
        });
    };
    EmsreportComponent.prototype.refreshData = function () {
        this.ngOnInit();
    };
    return EmsreportComponent;
}());
export { EmsreportComponent };
